import { composeIO } from 'react-compose-io'
import { fieldsTipoLancamentoIO } from './FieldsTipoLancamento.IO'
import { FieldsTipoLancamentoView } from './FieldsTipoLancamento.View'

export const FieldsTipoLancamento = composeIO(FieldsTipoLancamentoView, fieldsTipoLancamentoIO)
